export const HUB_API_URL = (import.meta.env.VITE_HUB_API_URL || 'http://localhost:8080').replace(
    /\/+$/,
    '',
);

// Shared secret the AWS ALB rule in front of the hub matches on (`X-Hub-Access`).
export const HUB_ACCESS_HEADER = import.meta.env.VITE_HUB_ACCESS_HEADER || '';
